module.exports = __webpack_public_path__ + "img/addressIcon.088bf984.svg";